import React from 'react';
import { Section } from './ui/Section';
import { Clock, HelpCircle, AlertTriangle, BatteryWarning } from 'lucide-react';
export function WhyOldSolutionsFail() {
  const reasons = [{
    icon: Clock,
    title: 'Demasiado largas',
    desc: 'Rutinas de una hora que nadie puede sostener en la vida real.'
  }, {
    icon: HelpCircle,
    title: 'Demasiado confusas',
    desc: '“Tomá esto, probá aquello” sin un orden claro.'
  }, {
    icon: AlertTriangle,
    title: 'Demasiado extremas',
    desc: 'Dietas restrictivas que te aíslan socialmente.'
  }, {
    icon: BatteryWarning,
    title: 'Dependen de energía',
    desc: 'Te piden fuerza de voluntad justo cuando estás agotada.'
  }];
  return <Section data-id="element-143">
      <h2 className="text-3xl md:text-4xl font-serif text-center mb-12 text-brand-text" data-id="element-144">
        Por qué lo que probaste no se sostuvo
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-145">
        {reasons.map((reason, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:border-brand-accent/50 transition-colors" data-id="element-146">
            <div className="w-12 h-12 rounded-full bg-brand-light flex items-center justify-center text-brand-primary mb-4" data-id="element-147">
              <reason.icon className="w-6 h-6" data-id="element-148" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-149">
              {reason.title}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-150">
              {reason.desc}
            </p>
          </div>)}
      </div>

      <p className="text-center mt-12 text-lg text-gray-600" data-id="element-151">
        Si todo requiere motivación, un día difícil te lo tira abajo.
      </p>
    </Section>;
}